import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Campaigns = () => {
    const base_url = process.env.REACT_APP_BASE_URL;
    const [campaigns, setCampaigns] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [sortOrder, setSortOrder] = useState('asc');
    const [newCampaign, setNewCampaign] = useState("");
    const [link, setLink] = useState("");
    const [category, setCategory] = useState("");
    const [status, setStatus] = useState("");
    const [imgFile, setImgFile] = useState(null);
    const [viewTitle, setViewTitle] = useState("");
    const [img, setImg] = useState("");
    const [viewStatus, setViewStatus] = useState("");
    const [viewID, setViewID] = useState("");
    const [selectedStatus, setSelectedStatus] = useState('');
    const [isPending, setIsPending] = useState(false)


    const [isCampaignPending, setIsCampaignPending] = useState(false)
    // const [addCampaignPending, setAddCampaignPending] = useState(false)

    const sortedCampaigns = sortOrder === 'asc' ? [...campaigns] : [...campaigns].reverse();
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentCampaigns = sortedCampaigns.slice(indexOfFirstItem, indexOfLastItem);

    const api = axios.create({
        baseURL: `${base_url}`
    });
    
    useEffect(() => {
        console.log(category);
    }, [category])
    // Set the authorization token for all requests
    api.interceptors.request.use((config) => {
        // Add your authorization token logic here
        const token = sessionStorage.getItem('token');
        config.headers.Authorization = `Bearer ${token}`;
        return config;
    });

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setIsCampaignPending(true)
        try {
            const response = await api.get(`${base_url}/campaign/all-campaign/`);
            setCampaigns(response.data.result);
            setIsCampaignPending(false)
        } catch (error) {
            console.log(error);
        }
    };

    const toggleSortOrder = () => {
        const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
        setSortOrder(newSortOrder);
    };

    const viewCampaign = (img, title, status, id) => {
        setImg(img);
        setViewTitle(title);
        setViewStatus(status);
        setViewID(id);
    };

    const [base64Image, setBase64Image] = useState('');

    const handleImageUpload = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            const reader = new FileReader();
            reader.onload = () => {
                const base64 = reader.result.split(',')[1];
                setBase64Image(base64);
            };
            reader.readAsDataURL(selectedFile);
        }
    };

    const handleSubmit = (event) => {
        setIsPending(true)
        event.preventDefault();
        const payload = {
            title: newCampaign,
            status: status,
            link: link,
            image: "data:image/jpeg;base64," + base64Image,
            category: category
        }
        //axios post request
        api.post(`${base_url}/campaign/add-advert/`, payload)
            .then(function (response) {
                console.log(response.data);
                setNewCampaign("");
                setStatus("");
                setImgFile(null);
                setLink("")
                setCategory("")
                addCampaignSuccess("Campaign Entry was successfully added");
                fetchData();
                setIsPending(false)
                // closeModal("add-campaign");
            })
            .catch(function (error) {
                // console.log(error.response.data.error);
                addCampaignError(error.response.data.error)
                setIsPending(false)
            });
    };

    const handleSubmitStatusChange = (event) => {
        event.preventDefault();

        const payload = {
            status: selectedStatus
        };

        api.post(`${base_url}/campaign/change-status/${viewID}`, payload)
            .then(function (response) {
                console.log(response.data);
                // Update the campaigns data or do any other necessary actions
                // Close the modal
                // closeModal("view-img");
                fetchData(); // Refresh the campaigns data
                changeStatusSuccess("Campaign status was successfully changed")
            })
            .catch(function (error) {
                console.log(error);
                changeStatusError("An error occurred and we couldnt complete your request")
                // Handle error here, e.g. display an error message
            });
    };

    // TOASTIFY CONTENT

    const addCampaignSuccess = (msg) =>
        toast.success(msg, {
            position: 'top-right',
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
        });
    const addCampaignError = (msg) =>
        toast.error(msg, {
            position: 'top-right',
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
        });

    const changeStatusSuccess = (msg) =>
        toast.success(msg, {
            position: 'top-right',
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
        });
    const changeStatusError = (msg) =>
        toast.error(msg, {
            position: 'top-right',
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
        });

    // Added by VM

    // navigation options
    const nextPage = () => {
        if (currentPage < Math.ceil(sortedCampaigns.length / itemsPerPage)) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const firstPage = () => {
        setCurrentPage(1);
    };

    const lastPage = () => {
        setCurrentPage(Math.ceil(sortedCampaigns.length / itemsPerPage));
    };

    const pageButtons = () => {
        const totalPages = Math.ceil(sortedCampaigns.length / itemsPerPage);
        const buttons = [];

        // Display up to 3 page numbers ahead of the current page
        for (let i = currentPage; i <= currentPage + 2 && i <= totalPages; i++) {
            buttons.push(
                <button
                    key={i}
                    className={`btn-pagination ${currentPage === i ? 'active-page' : ''}`}
                    onClick={() => setCurrentPage(i)}
                >
                    {i}
                </button>
            );
        }

        return buttons;
    };
    // end navigation options

    return (
        <div>
            <div className="d-flex my-1">
                <div className="pt-3">
                    <h6 className="section-title">
                        <i className="bi bi-list"></i> CAMPAIGNS
                        <small className="text-secondary" style={{ fontWeight: "400", fontSize: "smaller" }}> ({campaigns.length})</small>
                    </h6>
                </div>
                <div className="flex-fill text-end">
                    <button className="btn-custom" data-bs-toggle="modal" data-bs-target="#add-campaign">
                        <i className="bi bi-plus-circle"></i> Add
                    </button>
                    <button className="btn-custom ms-1" onClick={toggleSortOrder}>
                        {sortOrder === 'asc' ? <div><i className="bi bi-sort-down"></i> Sort</div> : <div><i className="bi bi-sort-up"></i> Sort</div>}
                    </button>
                </div>
            </div>
            <div className="table-responsive">
                <table className="table table-striped table-sm">
                    <thead className="table-dark">
                        <tr>
                            <th>ID</th>
                            <th>Title</th>
                            <th>Status</th>
                            <th>Image</th>
                            <th>View</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            isCampaignPending ? (
                                <tr>
                                    <td colSpan="5" className="text-center my-">
                                        <div className="spinner-border spinner-border-lg text-custom my-3"></div>
                                    </td>
                                </tr>
                            ) : (
                                currentCampaigns.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>{item.id}</td>
                                        <td>{item.title}</td>
                                        <td>{item.status}</td>
                                        <td><div style={{ display: "inline-block" }}><img src={item.image} alt="" style={{ width: "40px" }} className="small-img" /></div></td>
                                        <td>
                                            <button className="btn-custom-sm" data-bs-toggle="modal" data-bs-target="#view-img" onClick={() => viewCampaign(item.image, item.title, item.status, item.id)}>
                                                View
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )
                        }
                    </tbody>
                </table>

                {/* Added by VM */}
                <div className="pagination btn-group">
                    <button
                        className="btn-pagination"
                        onClick={firstPage}
                        disabled={currentPage === 1}
                    >
                        First
                    </button>

                    <button
                        className="btn-pagination"
                        onClick={prevPage}
                        disabled={currentPage === 1}
                    >
                        <i className="bi-chevron-left"></i>
                    </button>

                    {/* page numbered buttons */}
                    {pageButtons()}

                    <button
                        className="btn-pagination"
                        onClick={nextPage}
                        disabled={currentPage === Math.ceil(sortedCampaigns.length / itemsPerPage)}
                    >
                        <i className="bi-chevron-right"></i>
                    </button>

                    <button
                        className="btn-pagination"
                        onClick={lastPage}
                        disabled={currentPage === Math.ceil(sortedCampaigns.length / itemsPerPage)}
                    >
                        Last
                    </button>
                </div>
            </div>

            {/* <div className="pagination">
                {Array.from({ length: Math.ceil(sortedCampaigns.length / itemsPerPage) }, (_, index) => (
                    <button
                        key={index}
                        className={`${currentPage === index + 1 ? 'active-pagination-btn' : 'pagination-btn'}`}
                        onClick={() => paginate(index + 1)}
                    >
                        {index + 1}
                    </button>
                ))}
            </div> */}

            <div className="modal fade" id="add-campaign">
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title bold"><i className="bi bi-"></i> Add Campaign</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <form onSubmit={handleSubmit}>
                                    <div className="input-group my-3">
                                        <span className="input-group-text input-group-text-custom"><i className="bi bi-pencil"></i></span>
                                        <input type="text" className="form-control custom-input-group" value={newCampaign} onChange={(e) => setNewCampaign(e.target.value)} placeholder="Campaign" required />
                                    </div>
                                    <div className="input-group my-3">
                                        <span className="input-group-text input-group-text-custom"><i className="bi bi-check-circle"></i></span>
                                        <input type="text" className="form-control custom-input-group" value={status} onChange={(e) => setStatus(e.target.value)} placeholder="Status"/>
                                    </div>
                                    <div className="input-group my-3">
                                        <span className="input-group-text input-group-text-custom"><i className="bi bi-link"></i></span>
                                        <input type="text" className="form-control custom-input-group" value={link} onChange={(e) => setLink(e.target.value)} placeholder="Link" required/>
                                    </div>
                                    <div className="input-group my-3">
                                        <span className="input-group-text input-group-text-custom"><i class="bi bi-collection"></i></span>
                                        <select className="form-control custom-input-group" value={category} onChange={(e) => setCategory(e.target.value)} required>
                                            <option value="" disabled selected hidden>Choose a category</option>
                                            <option value="Products">Products</option>
                                            <option value="Withdraw">Withdraw</option>
                                            <option value="Learning">Learning</option>
                                            <option value="Transactions">Transactions</option>
                                            <option value="Vacancies">Vacancies</option>
                                            <option value="Support">Support</option>
                                            <option value="No Category">No Category</option>
                                        </select>
                                    </div>
                                    <div className="input-group my-3">
                                        <input type="file" className="form-control custom-input-group" onChange={handleImageUpload} accept="image/*" required/>
                                    </div>
                                    {
                                        isPending ?
                                            <button type="submit" className="btn-custom w-100 disabled-btn" disabled>
                                                <span>Processing </span><span className="spinner-border spinner-border-sm ms-2"></span>
                                            </button>
                                            :
                                            <button type="submit" className="btn-custom w-100">Submit</button>
                                    }
                                    {/* <button type="submit" className="btn-custom w-100">Submit</button> */}
                                </form>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn-gray-sm" data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="view-img">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title text-uppercase"><i className="bi-eye"></i> View Campaign</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-bod">
                            <div className="">
                                <img className="card-img-top" src={img} alt="" />
                                <div className="card-body p-3 py-4">
                                    <div className="d-flex">
                                        <div className="flex-fill shadow-sm m-1 p-3">
                                            <h6 className="card-title text-custom"><i className="bi-body-text"></i> Campaign Title</h6>
                                            <p className="card-text">{viewTitle}</p>
                                        </div>
                                        <div className="flex-fill shadow-sm m-1 p-3">
                                            <h6 className="card-title text-custom"><i className="bi-activity"></i> Current Status</h6>
                                            <p className="card-text">{viewStatus}</p>
                                        </div>
                                        <div className="flex-fill shadow-sm m-1 p-3">
                                            {/* <h6 className="card-title text-custom"><i className="bi-activity"></i> Update Status</h6> */}
                                            <form onSubmit={handleSubmitStatusChange}>
                                                <div className="input-group">
                                                    <select
                                                        className="form-select custom-input"
                                                        value={selectedStatus}
                                                        onChange={(e) => setSelectedStatus(e.target.value)}
                                                    >
                                                        <option value="" className="bg-secondary">Select Status</option>
                                                        <option value="active">Active</option>
                                                        <option value="inactive">Inactive</option>
                                                        <option value="suspended">Suspended</option>
                                                        <option value="expired">Expired</option>
                                                    </select>
                                                    <button type="submit" className="btn-custom-sm ms-2">Change</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn-gray-sm" data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Campaigns;




